var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#486581",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.333 144.333c.92 0 1.667.747 1.667 1.667s-.746 1.667-1.667 1.667h-6.666v6.666c0 .92-.747 1.667-1.667 1.667s-1.667-.746-1.667-1.667v-6.666h-6.666c-.92 0-1.667-.747-1.667-1.667s.746-1.667 1.667-1.667h6.666v-6.666c0-.92.747-1.667 1.667-1.667s1.667.746 1.667 1.667v6.666h6.666z",
    transform: "translate(-216 -1624) translate(81 1488)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.124d3d2fccb3e98962a217153561877d.svg";
export { ForwardRef as ReactComponent };